import { render } from "./taskSearcher.vue?vue&type=template&id=89e1f2f2"
import script from "./taskSearcher.vue?vue&type=script&lang=js"
export * from "./taskSearcher.vue?vue&type=script&lang=js"

import "./taskSearcher.vue?vue&type=style&index=0&id=89e1f2f2&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__